<div class="dialog-container">
  <div class="dialog-heading">
    <h2 mat-dialog-title *ngIf="isNewStyle==false">{{'collectionById.newStyle.update' | translate}}</h2>
    <h2 mat-dialog-title *ngIf="isNewStyle==true">{{'collectionById.newStyle.create' | translate}}</h2>
    <span class="spacer"></span>
    <div class="btn-close">
      <button (click)="closeDialog()" mat-icon-button mat-dialog-close aria-label="Close Dialog">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <mat-dialog-content class="mat-typography">
    <form [formGroup]="basicDetailsForm" novalidate>
      <div class="form-wrapper">
        <div class="input-wrapper">
          <div class="input-label">
            <label>{{'collectionById.newStyle.inputName' | translate}}</label> <span class="required">*</span>
          </div>
          <div class="input-field">
            <input type="text" rows="1" maxlength="121" class="form-control" formControlName="styleName" [readonly]='isPublished'>
            <div *ngIf="f.styleName.invalid && (f.styleName.dirty || f.styleName.touched) && !f.styleName.errors?.whitespace" class="alert alert-danger">
              <div *ngIf="f.styleName.errors?.required">{{'collectionById.newStyle.nameError1' | translate}}</div>
              <div *ngIf="f.styleName.errors?.minlength">{{'collectionById.newStyle.nameError2' | translate}}</div>
              <div *ngIf="f.styleName.errors?.maxlength">{{'collectionById.newStyle.nameError3' | translate}}</div>
              <div *ngIf="f.styleName.errors?.pattern">{{'collectionById.newStyle.nameError4' | translate}}</div>
            </div>
          </div>
        </div>
        <div class="input-wrapper">
          <div class="input-label">
            <label>{{'collectionById.newStyle.inputDesc' | translate}}</label>
          </div>
          <div class="input-field">
            <textarea type="text" rows="8" maxlength="481" class="form-control textarea" formControlName="description" [readonly]='isPublished'></textarea>
            <div *ngIf="f.description.invalid && (f.description.dirty || f.description.touched)" class="alert alert-danger">
              <div *ngIf="f.description.errors?.minlength">{{'collectionById.newStyle.descError1' | translate}}</div>
              <div *ngIf="f.description.errors?.maxlength">{{'collectionById.newStyle.descError2' | translate}}</div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-flat-button color="" (click)='saveStyle()' mat-raised-button class="btn-primary"
      [disabled]='basicDetailsForm.invalid'>{{'collectionById.newStyleGroups.btnSave' | translate}}</button>
  </mat-dialog-actions>
</div>
